export default {
    SET_CONTRACT(state, contract) {
        state.contract = contract
    }
}
